import { Box, CssBaseline, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import { useDispatch } from "react-redux";
import { seteditedNewgroups } from "../redux/businessSlice";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { AddDeviceId } from "../redux/adminSlice";
import { useHydrateHierarchy } from "../hooks/useHydrateHierarchy";
import { useGetGroupsQuery } from "../redux/organizationApi";

const Dashboardnav = ({ type }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const hydrateHierarchy = useHydrateHierarchy();
  const { data: groups } = useGetGroupsQuery();
  const location = useLocation();
  const isOrganisationalChart = String(location.pathname || "")
    .toLowerCase()
    .includes("/organisational-chart".toLowerCase());

  useEffect(() => {
    const getDeviceId = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      // console.log(result,"this is device id .................");
      // console.log(result.visitorId,"this is vister id .................");
      dispatch(AddDeviceId(result?.visitorId));
    };
    getDeviceId();
  }, []);

  useEffect(() => {
    if (hydrateHierarchy.status === "pending") {
      setLoading(true);
    } else if (
      hydrateHierarchy.status === "fulfilled" ||
      hydrateHierarchy.status === "rejected"
    ) {
      setLoading(false);
    }
  }, [hydrateHierarchy.status]);

  useEffect(() => {
    if (groups && Array.isArray(groups.groups)) {
      dispatch(seteditedNewgroups(groups.groups));
    }
  }, [dispatch, groups]);

  return (
    <Box
      className=""
      sx={{
        backgroundColor: "white",
        // padding: '20px 0px 0px 20px',
        minHeight: "100vh",
      }}
    >
      <Box
        className=""
        sx={{ display: "flex", backgroundColor: "white", height: "100vh" }}
      >
        <CssBaseline />
        <Header />
        <Box
          className="px-3 px-md-3  pb-2  scroll"
          style={{
            backgroundColor: "white",
            borderRadius: "20px",
            height: "calc(100vh - 8px)",
            scrollbarWidth: "none",
          }}
          component="main"
          sx={{
            flexGrow: 1,

            width: { md: `calc(100% - ${240}px)`, overflow: "auto" },
            paddingTop: "70px",
          }}
        >
          {/* <Toolbar /> */}
          {loading && !isOrganisationalChart ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "400px",
              }}
            >
              <CircularProgress size={30} sx={{ color: "#003B93" }} />
            </Box>
          ) : (
            <Outlet context={{ type }} />
          )}

          {/* <Outlet context={{ type }} /> */}
          {/* <Footer/> */}
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboardnav;
